import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const REPORTS_API_URL = environment.apiUrl + 'reports';

@Injectable({
  providedIn: 'root'
})

export class ReportService {

  constructor(private http: HttpClient) { }
  
  getFilteredReportsTournaments(query:string) {
    return this.http.get(`${REPORTS_API_URL}/tournamentfilters${query}`);
  }

  getUserReport(query:string) {
    return this.http.get(`${REPORTS_API_URL}/user_reports${query}`);
  }

  getActiveUserReport(query:string) {
    return this.http.get(`${REPORTS_API_URL}/activeUsersreport${query}`);
  }

  getUserJourney(query:string) {
    return this.http.get(`${REPORTS_API_URL}/userJourney${query}`);
  }

  getRevenueReport(query:string) {
    return this.http.get(`${REPORTS_API_URL}/revenue${query}`);
  }

  getAcademyAffiliationRevenue(query:string) {
    return this.http.get(`${REPORTS_API_URL}/academyAffiliationRevenue${query}`);
  }

  getTournamentRevenue(query:string) {
    return this.http.get(`${REPORTS_API_URL}/tournamentRevenue${query}`);
  }

  getCourtBookingsRevenue(query:string) {
    return this.http.get(`${REPORTS_API_URL}/courtBookingRevenue${query}`);
  }

  getUserSubscriptions(query:string) {
    return this.http.get(`${REPORTS_API_URL}/academyUserSubscription${query}`);
  }

  getAttendanceReport(query:string) {
    return this.http.get(`${REPORTS_API_URL}/academyAttendancereport${query}`);
  }

  getPerformanceAnalytics(query:string) {
    return this.http.get(`${REPORTS_API_URL}/adminPerformaceanalyticsreport${query}`);
  }

  getAERReport(query:string) {
    return this.http.get(`${REPORTS_API_URL}/academyEnrolmentRevenue${query}`);
  }

  getFAPRReport(query:string) {
    return this.http.get(`${REPORTS_API_URL}/academyfindaPartnerRevenue${query}`);
  }
}
